import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["destroyField", "existingVideo", "uploadFields", "removeButton", "undoButton", "removalNotice", "fileInput"]

  markForRemoval() {
    this.destroyFieldTarget.value = "1"
    this.existingVideoTarget.classList.add("opacity-40", "pointer-events-none")
    this.removalNoticeTarget.classList.remove("hidden")
    this.uploadFieldsTarget.classList.add("hidden")
    this.removeButtonTarget.classList.add("hidden")
    this.undoButtonTarget.classList.remove("hidden")

    if (this.hasFileInputTarget) {
      this.fileInputTarget.value = ""
    }
  }

  undoRemoval() {
    this.destroyFieldTarget.value = "0"
    this.existingVideoTarget.classList.remove("opacity-40", "pointer-events-none")
    this.removalNoticeTarget.classList.add("hidden")
    this.uploadFieldsTarget.classList.remove("hidden")
    this.removeButtonTarget.classList.remove("hidden")
    this.undoButtonTarget.classList.add("hidden")
  }

  fileSelected() {
    if (this.destroyFieldTarget.value === "1") {
      this.undoRemoval()
    }
  }
}
